import React, { useEffect, useState } from 'react';
import { Paper, Grid } from '@material-ui/core';

import api from 'services/api';
import { useSnackbar, useUser } from 'hooks';

import {
  Header,
  SquareTable,
  TableOptionId,
  AddProductsModal,
  TableRequestModal,
} from './components';
import useStyles from './styles';
import { RequestProductList } from './components/AddProductsModal/RequestProductList';

export default function RequestsTablesAdd() {
  const [isStartSericeDialogVisible, setIsStartSericeDialogVisible] =
    useState(false);
  const [isAddProductModalVisible, setIsAddProductModalVisible] =
    useState(false);
  const [isRequestModalVisible, setIsRequestModalVisible] = useState(false);
  const classes = useStyles();
  const [tables, setTables] = useState([]);
  const { user } = useUser();
  const { openSnackbar } = useSnackbar();

  const getTables = async () => {
    try {
      const response = await api.get(
        `/restaurants/${user.restaurant_id}/tables`,
      );
      setTables(response.data.tables);
    } catch (error) {
      console.log((error.response && error.response.data) || error);
    }
  };

  const handleTableOption = (option) => {
    switch (option.id) {
      case TableOptionId.START_SERVICE: {
        setIsStartSericeDialogVisible(true);
        break;
      }
      case TableOptionId.ADD_PRODUCT: {
        setIsAddProductModalVisible(true);
        break;
      }
      case TableOptionId.SHOW_REQUEST: {
        setIsRequestModalVisible(true);
        break;
      }
      default:
        break;
    }
  };

  const handleCloseAddProductModal = () => {
    reload();
    setIsAddProductModalVisible(false);
  };

  const handleCloseRequestModal = () => {
    reload();
    setIsRequestModalVisible(false);
  };

  const handleCloseStartServiceModal = () => {
    reload();
    setIsStartSericeDialogVisible(false);
  };

  const squareType = (status) => {
    if (status === 1) {
      return 'available';
    } else if (status === 2) {
      return 'orderInProgress';
    } else {
      return 'busyWithoutOrder';
    }
  };

  const reload = () => {
    getTables();
  };

  useEffect(() => {
    getTables();
  }, []);

  const handleDoRequest = async (payload) => {
    try {
      const { data } = await api.post('requests/products', payload);

      handleCloseAddProductModal();
      openSnackbar(data.message, 'success');
    } catch {
      openSnackbar('Falha ao adicionar produtos.', 'error');
    }
  };

  const handleStartService = async (payload) => {
    try {
      const { data } = await api.post('requests', payload);

      handleCloseStartServiceModal();
      openSnackbar(data.message, 'success');
    } catch {
      openSnackbar('Falha ao iniciar atendimento.', 'error');
    }
  };

  return (
    <>
      <Header title="Mesas" />
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          {tables.map((table) => (
            <Grid key={table.id} item xs={6} sm={4} md={3} lg={2}>
              <SquareTable
                type={squareType(table.status)}
                key={table.id}
                table={table}
                onClickOption={handleTableOption}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>

      <AddProductsModal
        isVisible={isStartSericeDialogVisible}
        restaurantId={user.restaurant_id}
        onDismiss={handleCloseStartServiceModal}
      >
        <RequestProductList
          restaurantId={user.restaurant_id}
          onDoRequest={handleStartService}
        />
      </AddProductsModal>

      <AddProductsModal
        isVisible={isAddProductModalVisible}
        restaurantId={user.restaurant_id}
        onDismiss={handleCloseAddProductModal}
      >
        <RequestProductList
          restaurantId={user.restaurant_id}
          onDoRequest={handleDoRequest}
        />
      </AddProductsModal>

      <TableRequestModal
        isVisible={isRequestModalVisible}
        onClose={handleCloseRequestModal}
      />
    </>
  );
}
